const initialState = {
  isLoading: false,
  order: {},
  newOrder: {},
  currentData: {},
  details: {},
  errors: null,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "order_List_range_req":
      return {
        ...state,
        isLoading: true,
      };
    case "order_List_range_Success":
      return {
        ...state,
        isLoading: false,
        order: action.payload,
      };
    case "order_List_range_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };


    case "order_List_req":
      return {
        ...state,
        isLoading: true,
      };
    case "order_List_Success":
      return {
        ...state,
        isLoading: false,
        order: action.payload,
      };
    case "order_List_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "order_req_delete":
      return {
        ...state,
        isLoading: true,
      };
    case "order_delete":
      return {
        ...state,
        isLoading: false,
        order: action.payload,
      };
    case "order_delete_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "order_req_cancel":
      return {
        ...state,
        isLoading: true,
      };
    case "order_cancel":
      return {
        ...state,
        isLoading: false,
        order: action.payload,
      };
    case "order_cancel_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };

    case "order_req_rate":
      return {
        ...state,
        isLoading: true,
      };
    case "order_rate":
      return {
        ...state,
        isLoading: false,
      };
    case "order_rate_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "add_order_req":
      return {
        ...state,
        isLoading: true,
      };
    case "add_order_success":
      return {
        ...state,
        isLoading: false,
        newOrder: action.payload,
      };
    case "add_order_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "edit_order_req":
      return {
        ...state,
        isLoading: true,
      };
    case "edit_order_success":
      return {
        ...state,
        isLoading: false,
        newOrder: action.payload,
      };
    case "edit_order_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "set_order_details":
      return {
        ...state,
        loading: false,
        currentData: action.payload,
      };
    case "reset_order_details":
      return {
        ...state,
        loading: false,
        currentData: {},
      };
    default:
      return state;
  }
};

export { orderReducer };
